// src/components/UserSideComponents/packages/PackageSlotStep.jsx
import SlotSelectionCard from "../bookings/SlotSelectionCard";

const PackageSlotStep = ({ bookingData, setBookingData }) => {
  return (
    <div className="p-4">
      <SlotSelectionCard
        bookingData={bookingData}
        setBookingData={setBookingData}
        isPage={false}
      />
    </div>
  );
};

export default PackageSlotStep;